import React, { useEffect, useState } from "react";
import { ShowToast } from "../../../../helpers/ToastService";
import WeightFactor from "./WeightFactor";
import { updateCategory } from "../../../../api/helper";
import AddCategoryAndQuestions from "../AddCategoryAndQuestions";

function CategoryList({
  categories,
  setCategories,
  GetFetchcategoriescreate,
  handelDeleteCategory,
}) {
  const [loading, setLoading] = useState(false);
  const [totalWeight, setTotalWeight] = useState(1);
  const [ismodal, setIsModal] = useState(false);
  const [editValue, setEditValue] = useState({});

  const handleUpdateWeight = async (value, cateId) => {
    try {
      await updateCategory(cateId, { weight: value });
      const updatedCategories = categories.map((cat) =>
        cat._id === cateId ? { ...cat, weight: value } : cat
      );
      setCategories(updatedCategories);
      ShowToast("Weight factor updated successfully", "success");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (categories) {
      let total = 0;
      categories?.map((item) => {
        const weight = item?.weight || 0;
        return (total += weight);
      });
      setTotalWeight(Number.parseFloat(total.toFixed(2)));
    }
  }, [categories]);

  const editACategory = (item) => {
    setEditValue(item);
    setIsModal(true);
  };

  const CloseModal = () => {
    setIsModal(false);
  };
  console.log(editValue, "editValue=======");
  return (
    <>
      <div className="bg-white w-full pt-10 mx-auto"
      >
        {ismodal && (
          <AddCategoryAndQuestions
            CloseModal={CloseModal}
            GetFetchcategoriescreate={GetFetchcategoriescreate}
            editValue={editValue}
          />
        )}
        <div>
          <table className="table" id="questionnaireTable">
            <thead>
              <tr>
                <th>Category Name</th>
                <th>Short Name</th>
                <th>Weight </th>
                <th>Questions</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories?.map((item, index) => (
                <tr key={index}>
                  <td>{item?.name}</td>
                  <td>{item?.abbreviation}</td>
                  {/* <td>{item?.weight}</td> */}
                  <WeightFactor
                    initialValue={item?.weight || 0}
                    onUpdate={handleUpdateWeight}
                    cateId={item?._id}
                  />
                  {/* <td>
                    <button className="w-full">
                      {item?.questions?.length}
                    </button>
                  </td> */}
                  <td>
                    <span className="badge_CategoryList active" style={{width:30,alignItems:'center',justifyContent:'center',display:'flex'}}>
                      
                      {item?.questions?.length}
                    </span>
                  </td>
                  <td>{item?.status || "Active"}</td>
                  <td>
                    <button className="action_icon_btn">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button className="action_icon_btn">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                  {/* <button
                      onClick={() => editACategory(item)}
                      disabled={item?.isPreData ? true : false}
                      className={`${
                        item?.isPreData && "cursor-not-allowed opacity-50"
                      } action-button bg-yellow-400 text-black`}
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => {
                        const confirm = window.confirm(
                          "Are you sure you want to delete this category?"
                        );
                        if (confirm) {
                          handelDeleteCategory(item._id);
                        }
                      }}
                      disabled={item?.isPreData ? true : false}
                      className={`${
                        item?.isPreData && "cursor-not-allowed opacity-50"
                      } action-button bg-red-500`}
                    >
                      {loading ? "Deleting..." : "Delete"}
                    </button> */}
                </tr>
              ))}
            </tbody>
          </table>

          <p className="mt-2">
            {totalWeight < 1.0 && totalWeight !== 0 ? (
              <span className="text-orange-500 font-semibold">
                Total weight must add up to 1.0. You have{" "}
                <span className={`font-bold text-green-500`}>
                  {(1 - totalWeight).toFixed(3)}
                </span>{" "}
                to allocate. Please adjust the weights.
              </span>
            ) : (
              totalWeight > 1.0 && (
                <span className="text-orange-500 font-semibold">
                  Total weight must add up to 1.0. You weight allocation is over
                  the limit by{" "}
                  <span className={`font-bold text-red-500`}>
                    {(1 - totalWeight).toFixed(3)}
                  </span>{" "}
                  . Please adjust the weights.
                </span>
              )
            )}
          </p>
        </div>
      </div>
    </>
  );
}

export default CategoryList;
